// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationFilledSvg from "@ant-design/icons-svg/es/asn/NotificationFilled";
import AntdIcon from '../components/AntdIcon';

var NotificationFilled = function NotificationFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationFilledSvg
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
export default React.forwardRef(NotificationFilled);